module.exports = __webpack_public_path__ + "media/images/sp/stores/fukuoka/fukuoka_sns_02-2a223528018dcd65a8f588b693c967fb.jpg";